import { render } from "./error-banner.vue?vue&type=template&id=fd863972"
import script from "./error-banner.js?vue&type=script&lang=js&external"
export * from "./error-banner.js?vue&type=script&lang=js&external"

import "./error-banner.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__